import { getAwsAssets } from "@src/utils";
import { Image } from "@src/components/Image";
import { useLayoutEffect, useState } from "react";
import styles from "./OverviewAlertBox.module.scss";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
import { useDispatch, useSelector } from "react-redux";
import Button from "@src/components/UIElements/Button";
import RefreshIcon from "../RefreshIcon";

const paymentProcessingData = {
  icon: getAwsAssets("clockIcon.svg", "bottomSheets"),
  bgColor: "#5AB369",
  heading: t(
    "components.tabs.overview.components.overviewAlertBox.index.paymentProcessingDataHeading",
    "Payment Processing"
  ),
  subheading: t(
    "components.tabs.overview.components.overviewAlertBox.index.paymentProcessingDataText",
    "Your payment is currently under processing. Please wait for sometime."
  ),
};
const lockedCourseData = {
  icon: getAwsAssets("LockedAlertIcon.svg", "Overview"),
  bgColor: "#ff4058",
  heading: t(
    "components.tabs.overview.components.overviewAlertBox.index.lockedCourseDataHeading",
    "Course Locked"
  ),
  subheading: t(
    "components.tabs.overview.components.overviewAlertBox.index.lockedCourseDataText",
    "Pay your pending installments to unlock and access your course now."
  ),
};

const OverviewAlertBox = ({ isCourseLocked, isPaymentProcessing, onClick }) => {
  const [data, setData] = useState({});
  const { t } = useTranslation();

  const paymentProcessingBox = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.paymentStatusEmblem
  );

  useLayoutEffect(() => {
    if (isCourseLocked) {
      setData(lockedCourseData);
    } else if (isPaymentProcessing) {
      setData(paymentProcessingBox);
    }
  }, []);
  const {
    icon,
    heading,
    subheading,
    bgColor,
    subheading1,
    subheading2,
    subheading3,
    headingColor,
    subheadingColor,
  } = data;
  return (
    <div
      className={styles.overviewAlertBoxWrapper}
      style={{ background: bgColor }}
    >
      <div className={styles.overviewAlertBox} style={{ background: bgColor }}>
        <div className={styles.overviewAlertBox__icon}>
          {/* <Image
            src={icon ? icon : getAwsAssets("LockedAlertIcon", "Overview")}
            alt="icon"
            width={32}
            height={32}
          /> */}
        </div>
        <div className={styles.overviewAlertBox__text}>
          {heading ? (
            <h4 style={headingColor ? { color: headingColor } : {}}>
              {heading}
            </h4>
          ) : (
            ""
          )}
          {subheading ? (
            <p style={subheadingColor ? { color: subheadingColor } : {}}>
              {subheading}
            </p>
          ) : (
            ""
          )}
          {subheading1 ? (
            <p style={subheadingColor ? { color: subheadingColor } : {}}>
              {subheading1}
            </p>
          ) : (
            ""
          )}
          {subheading2 ? (
            <span
              style={{
                fontWeight: "bold",
                color: subheadingColor ? subheadingColor : "#fff",
              }}
            >
              {subheading2}
            </span>
          ) : (
            ""
          )}
          {subheading3 ? (
            <p style={subheadingColor ? { color: subheadingColor } : {}}>
              {subheading3}
            </p>
          ) : (
            ""
          )}
          {onClick ? (
            <Button
              onClick={onClick}
              outline
              small
              style={{
                boxShadow: "none",
                border: "1px solid #ffffff",
                backgroundColor: "transparent",
                color: "#ffffff",
                display: "flex",
                alignItems: "center",
              }}
            >
              <span style={{ marginRight: "6px" }}>Refresh</span>
              <RefreshIcon width="14" height="14" />
            </Button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default OverviewAlertBox;
